import type {
  CustomizationCategory,
  MaterialPaintRegions,
} from '../../constants/customizationCategories';
import { isCategoryEqual } from '../../constants/customizationCategories';
import type { DesignerPartnerProductConfiguration } from '../../constants/partners';
import { DesignerPartner, PARTNER_PRODUCT_MAP } from '../../constants/partners';

export const isCobrandCategory = (
  brandTypes: MaterialPaintRegions[] | undefined,
  category: CustomizationCategory | null,
) => {
  if (!brandTypes || !category) return false;

  return (
    (brandTypes.includes('paint') && category.type === 'paint') ||
    (brandTypes.includes(category.region) && category.type !== 'paint')
  );
};

const findConfiguration = (
  category: CustomizationCategory,
  configurations: DesignerPartnerProductConfiguration[],
) =>
  configurations.find(configuration =>
    isCategoryEqual(configuration.category, category),
  );

/**
 * Given a customization category and partner, find the partner category
 * configuration that category, if it exists.
 *
 * @param category customization category (i.e. from `useCustomization`)
 * @param partner designer partner key
 *
 * @returns category configuration which includes partner configuration specific
 * to the category such as the Product Catalog category UUID and Product Catalog
 * facet configuration
 */
export const getPartnerProductConfiguration = (
  category: CustomizationCategory | undefined | null,
  partner: DesignerPartner | undefined | null,
) => {
  if (!category || !partner) return null;

  const partnerConfiguration = findConfiguration(
    category,
    PARTNER_PRODUCT_MAP[partner],
  );

  return (
    partnerConfiguration ??
    findConfiguration(category, PARTNER_PRODUCT_MAP[DesignerPartner.NONE])
  );
};
